import { Injectable } from '@angular/core';
import {CanLoad, Route, UrlSegment} from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from '../../user-services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthCanLoadGuard implements CanLoad {

  constructor(private authService: AuthService) { }

  canLoad(route: Route, segments: UrlSegment[])
    : Observable<boolean> | Promise<boolean> | boolean {

    return this.authService.isLoggedIn().then(res => {
      return res ? true : this.login();
    });

    //   const currentUser = this.authService.user;
    //   if (currentUser) {
    //     // console.log('Lei è loggato: ' + JSON.stringify(currentUser));
    //     return true;
    //   }
    //   this.authService.login().then();
    //   return false;
    // }
  }

  private login() {
    this.authService.login();
    return false;
  }
}
